export default "mutation updateTeachUnit($update: TeachUnitUpdateRequest) {\n  updateTeachUnit(update: $update) {\n\t\t_ALL_\n\t}\n}";